<template>
  <v-row>
    <v-col sm="12" md="6">
      <v-card outlined>
        <v-progress-linear
          class="ma-auto"
          :active="loading"
          :indeterminate="true"
        />
        <v-card-title v-if="!loading">
          <strong>
            #{{ person.id }} - {{ person.title }}
            {{ person.firstname }}
            {{ person.middlenames }}
            {{ person.surname }} ({{ person.nickname }})
          </strong>
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-layout column>
            <v-flex v-if="activeScope">
              Current Scope:
              <em>{{ activeScope }}</em>
            </v-flex>
            <v-flex v-else>
              <em><strong>No Current Scope of Practice</strong></em>
            </v-flex>
            <v-flex
              v-if="person.practitioner && person.practitioner.practicingstatus"
            >
              Practicing Status:
              <em>{{ person.practitioner.practicingstatus.name }}</em>
            </v-flex>
            <v-flex v-else>
              <em><strong>No Practicing Status</strong></em>
            </v-flex>

            <v-flex v-if="person.postcodeinfo">
              Region:
              <em>{{ person.postcodeinfo.region }}</em>
            </v-flex>
            <v-flex v-if="person.contactemailaddress"
              >Email:
              <a :href="'mailto:' + person.contactemailaddress">{{
                person.contactemailaddress
              }}</a>
            </v-flex>
            <v-flex v-if="person.apc">
              <v-icon color="success">check</v-icon>Certificate:
              <strong>( {{ person.apc.certificatetype.name }} ) </strong>
              <em> {{ person.apc.startdate | formatDate }} - </em>
              {{ person.apc.expirydate | formatDate }}
            </v-flex>
            <v-flex v-else>
              <em><strong>No Active Certificate</strong></em>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn :to="'/people/' + person.id" color="primary">
            Open
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col sm="12" md="6">
      <public-register-preview :person-id="person.id" />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import mapState from "vuex";
import publicRegisterPreview from "@/components/pharmacists/public-register-preview";

export default {
  name: "personSummary",
  data() {
    return {
      errors: [],
      loading: false
    };
  },
  computed: {
    person() {
      return this.$store.getters.getById(this.personId);
    },
    activeScope() {
      try {
        return this.person?.practitioner?.scopesonpractice?.find(s => {
          return !s.inactive && !s.inactivedate;
        }).scopesofpractice.name;
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    // pharmacist() {
    //   let profile = this.$store.state.register.currentProfile;
    //   console.log("refreshing pharmacist from state");
    //   if (!profile) return {};
    //   return profile;
    // },
    async loadPerson(personId) {
      if (!personId) {
        return;
      }
      this.loading = true;
      try {
        await this.$store.dispatch("load", personId);
      } catch (e) {
        this.errors.push(e.message);
      }

      this.loading = false;
      // console.log(profile);
      console.log("person loaded: ", personId);
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  props: {
    personId: Number
  },
  watch: {
    personId: {
      handler: "loadPerson",
      immediate: true
    }
    // pharmacist: {
    //   handler: "loadPerson"
    // }
  },
  filters: {},
  components: {
    publicRegisterPreview
  }
};
</script>
